import { render } from "./OverviewFiles.vue?vue&type=template&id=c752e37c&scoped=true"
import script from "./OverviewFiles.vue?vue&type=script&lang=js"
export * from "./OverviewFiles.vue?vue&type=script&lang=js"

import "./OverviewFiles.vue?vue&type=style&index=0&id=c752e37c&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c752e37c"]])

export default __exports__